import { ToastProgrammatic } from 'buefy';
import i18n from '@/localization/localization';

export const showSuccessNotification = (translationKey) => {
    ToastProgrammatic.open({
        duration: 3000,
        message: i18n.t(translationKey).toString(),
        type: 'is-success',
    });
};
